export default class scrollFollow {
    constructor() {
        return {
            restrict: 'A',
            controller: [
                '$scope', '$element', '$attrs', '$window',
                (scope, element, attr, $window) => {
                var window = angular.element($window);
                var offset;

                angular.element(window).bind('scroll', function() {
                    offset = element.parent().offset();
                    if (window.scrollTop() > offset.top) {
                        element.stop().animate({
                            top: window.scrollTop() - offset.top
                        }, 0);
                    } else {
                        element.stop().animate({
                            top: 0
                        }, 0);
                    }

                    scope.visible = false;
                    scope.$apply();
                });

                scope.$on('$destroy', function () {
                    window.off('scroll');
                });
            }]
        }
    }
}